import qs from "qs";

import { axiosWithAuth, convertDateToISO, TIME_OFFSET_DAY_END } from "helpers";
import { ageMaximum, ageMinimum } from "mappers";

export const boardingQueueService = {
	claimToUserBoarding,
	getAppContactInformation,
	getAssignableUsersBoarding,
	getBoardingList,
	unclaimToUserBoarding,
	updateAppContactInformation,
	updateBoardingDbaName,
	updateBoardingDiscoverMid,
	updateBoardingAmexSeNumber,
	updateBoardingLegalName,
	updateBoardingMccCode,
	updateBoardingMid,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getBoardingList({ tab, page, filters, sortBy }) {
	const options = {
		url: `${API_URL}/api/applications/boarding/${tab}`,
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			sort_type: sortBy?.id || undefined,
			ascending: sortBy?.id ? sortBy?.desc : undefined,
			// filters
			number: filters?.number,
			auto_boarding_status: filters?.auto_boarding_status
				? filters?.auto_boarding_status.value
				: undefined,
			agent_name: filters?.agentName,
			agent_office: filters?.agentOffice,
			merchant_name: filters?.merchant_name,
			processor_id: filters?.processor?.id,
			sponsor_id: filters?.sponsor?.id,
			boarding_ach_status: filters?.boardingAchStatus?.value,
			boarding_outcome: filters?.boardingOutcome?.name,
			pend_status: filters?.pendStatus?.value,
			pend_reason_id: filters?.pendReason?.id,
			pended_to_id: filters?.pendedTo?.id,
			pended_from: convertDateToISO(filters?.ageOfPendFrom),
			pended_to: convertDateToISO(filters?.ageOfPendTo, {
				addTime: TIME_OFFSET_DAY_END,
			}),
			boarder_assignee_id: filters?.assignedTo?.id,
			mid: filters?.mid,
			boarding_completed_from: convertDateToISO(filters?.completeFrom),
			boarding_completed_to: convertDateToISO(filters?.completeTo, {
				addTime: TIME_OFFSET_DAY_END,
			}),
			age_in_boarding_from: ageMinimum(filters),
			age_in_boarding_to: ageMaximum(filters),
			sub_status_ids: filters?.completeStatus?.value,
		},
		paramsSerializer: params =>
			qs.stringify(params, { arrayFormat: "repeat" }),
	};

	return axiosWithAuth(options);
}

function claimToUserBoarding({ id, userId }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/boarding/${id}/assign`,
		data: { user_id: userId },
	};

	return axiosWithAuth(options);
}

function unclaimToUserBoarding(id) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/boarding/${id}/unassign`,
	};

	return axiosWithAuth(options);
}

function getAssignableUsersBoarding(search, page_index, show_inactive = false) {
	const params = {
		search,
		page_index,
		page_size: 20,
		show_inactive,
	};

	const options = {
		method: "GET",
		params,
		url: `${API_URL}/api/applications/boarding/assignable_users`,
	};

	return axiosWithAuth(options);
}

function updateBoardingDbaName({ appId, dba_name }) {
	const options = {
		method: "POST",
		data: { dba_name },
		url: `${API_URL}/api/applications/boarding/${appId}/change_dba_name`,
	};

	return axiosWithAuth(options);
}

function updateBoardingMccCode({ appId, mcc_code, mcc_alias_id }) {
	const options = {
		method: "POST",
		data: { mcc_code, mcc_alias_id },
		url: `${API_URL}/api/applications/boarding/${appId}/change_mcc`,
	};

	return axiosWithAuth(options);
}

function updateBoardingMid({ appId, mid }) {
	const options = {
		method: "POST",
		data: { mid },
		url: `${API_URL}/api/applications/boarding/${appId}/change_mid`,
	};

	return axiosWithAuth(options);
}

function updateBoardingDiscoverMid({ appId, discoverMid }) {
	const options = {
		method: "POST",
		data: { discovery_mid: discoverMid },
		url: `${API_URL}/api/applications/boarding/${appId}/change_discovery_mid`,
	};

	return axiosWithAuth(options);
}

function updateBoardingAmexSeNumber({ appId, amexSeNumber }) {
	const options = {
		method: "POST",
		data: { amex_se_number: amexSeNumber },
		url: `${API_URL}/api/applications/boarding/${appId}/change_amex_se_number`,
	};

	return axiosWithAuth(options);
}

function updateBoardingLegalName({ appId, legal_name }) {
	const options = {
		method: "POST",
		data: { legal_name },
		url: `${API_URL}/api/applications/boarding/${appId}/change_legal_name`,
	};

	return axiosWithAuth(options);
}

function getAppContactInformation(appId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/boarding/${appId}/contact_information`,
	};

	return axiosWithAuth(options);
}

function updateAppContactInformation(appId, contactInfo) {
	const options = {
		method: "POST",
		data: contactInfo,
		url: `${API_URL}/api/applications/boarding/${appId}/change_contact_information`,
	};

	return axiosWithAuth(options);
}
